import React from 'react';
import { Box, Typography } from '@mui/material';

const SettingsPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Settings</Typography>
      <Typography variant="body1">Settings functionality will be implemented here.</Typography>
    </Box>
  );
};

export default SettingsPage; 